/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.model

import io.kvision.core.Component
import io.kvision.form.FormControl
import io.kvision.form.text.Text
import io.kvision.form.text.TextArea
import io.kvision.form.time.DateTime
import io.kvision.html.*
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.generator.FormStructure
import pl.finn.forms.utils.form.FormBuilder
import pl.finn.forms.utils.form.FormElement

class MaterialComponents(state: FormStructure, reference: FormBuilder<DocumentTreeNode>) {

  private val apiRequest = state.model
  private val formReference = reference

  fun createAddresseeInput(element: DocumentTreeNode): FormControl {
    if (element.value.isNullOrEmpty()) element.value =
      (apiRequest?.get("ref_adresat_nazwa") ?: "") + "\n" + (apiRequest?.get("ref_adresat_adres") ?: "")
    val formElement = FormElement(
      element,
      TextArea() {
        placeholder = "Adresat"
        addCssClass("finn-form-group")
      },
      required = true,
      requiredMessage = POLE_WYMAGANE
    )
    formReference.getElement(formElement)
    return formElement.field
  }

  fun createDateTime(element: DocumentTreeNode): FormControl {
    val formElement = FormElement(
      element,
      DateTime(label = null, format = "YYYY-MM-DD") {
        addCssClass("finn-form-group")
        addCssClass("float-left")
      },
    )
    formReference.getElement(formElement)
    return formElement.field
  }

  fun createInputText(element: DocumentTreeNode): FormControl {
    if (element.value.isNullOrEmpty()) element.value = apiRequest?.get("ref_miejscowosc") ?: ""
    val formElement = FormElement(
      element,
      Text() {
        placeholder = "Miejscowość"
        addCssClass("finn-form-group")
        addCssClass("float-left")
        addCssClass("ml-md-5")
      },
      required = element.metaModel?.isElementRequired == true,
      requiredMessage = POLE_WYMAGANE,
    )
    formReference.getElement(formElement)
    return formElement.field
  }

  fun createNavigationButtons(): Component {
    return (
        Div(className = "space-between justify-end mt-4") {
          id = "buttons-container"
          button("Wstecz", className = "d-none") {
            id = "previous-button"
          }
          button("Dalej") {
            id = "next-button"
          }
        }
        )
  }

  fun createHeader(element: DocumentTreeNode): Component {
    return (
        H1(
          element.label,
          className = "h4 text-center mb-4"
        ) {
          tabindex = -1
        }
        )
  }
}